import React, { useEffect } from "react";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { translateApiError } from "../../helpers/translateApiError";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  const { t } = useTranslation();

  // Only show a toast when an error is passed in. Calling toast.error on
  // every render showed an empty error toast next to each spinner.
  useEffect(() => {
    if (!props.error) return;
    toast.error(translateApiError(props.error), {
      position: "top-right",
      hideProgressBar: false,
      progress: undefined,
    });
  }, [props.error]);

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Spinner color={props.color} size={props.size}>
        {t("common.loading")}
      </Spinner>
    </div>
  );
};

export default Loader;
